import { FilterOption, DistributorFilterModel } from './filter-options-types';


export const DistributorFilterModelOptions = (periodNames: string[]): FilterOption[] => {
    return [
          {
            id : 'partnerGroup',
            title: 'Partner Group', // Top heirarchy
            required: false,
            disabled: false,
            hidden: false,
            isMultiple: true,
            optionList: [],
            onChangeUpdate:[DistributorFilterModel.SecondLevelContractFilter, DistributorFilterModel.Accts],
            selected: [],
            level: 0, // Hide all levels > 0 if not selected
            isLoading: false,
            isSelectedFilter: true // This is used when we apply the saved filters need to show the selected filters
          },
          {
            id : 'distributorGroup',
            title: 'Distributor Group', // Second level heirarchy 
            required: false,
            disabled: false,
            hidden: false,
            isMultiple: true,
            optionList: [],
            onChangeUpdate:[DistributorFilterModel.Accts],
            selected: [],
            level: 0, // Hide all levels > 0 if not selected
            isLoading: false,
            isSelectedFilter: true // This is used when we apply the saved filters need to show the selected filters
          },
          {
            id: 'accountName',
            title: 'Account name', // L1 in prototype
            required: false,
            disabled: false,
            hidden: true,
            isMultiple: true,
            optionList: [],
            onChangeUpdate:[],
            selected: [],
            level: 1, // Hide all levels > 1 if not selected
            isLoading: false,
            isSelectedFilter: true // This is used when we apply the saved filters need to show the selected filters
          },
          {
            id: 'dateRange',
            title: 'Date Range',
            required: true,
            disabled: false,
            hidden: true,
            isMultiple: false,
            optionList: periodNames,
            onChangeUpdate:[],
            selected: [],
            level: 1, // Hide all levels > 1 if not selected
          },
    ]
}